// Results in R: a trade's result as a multiple of what it risked. The risk is the trade's own
// (`risk`, dollars typed in), else its first stop (`stopPrice`: points to the stop × point value
// × size), else the trader's usual risk per trade (Settings, set here by the journal when it
// loads). Without any of them a trade has no R.
import { pointValue } from './tools/contracts';
import { netPnl } from './pnl';

let usualRisk = null;
export const setUsualRisk = (n) => { usualRisk = Number(n) > 0 ? Number(n) : null; };
export const usualRiskPerTrade = () => usualRisk;

// { risk, from: 'risk' | 'stop' | 'usual' } or null.
export function riskOf(trade) {
  if (Number(trade.risk) > 0) return { risk: Number(trade.risk), from: 'risk' };
  if (Number.isFinite(trade.stopPrice) && Number.isFinite(trade.entryPrice)) {
    const risk = Math.abs(trade.entryPrice - trade.stopPrice) * (pointValue(trade.symbol) ?? 1) * (Number(trade.size) || 1);
    if (risk > 0) return { risk, from: 'stop' };
  }
  return usualRisk ? { risk: usualRisk, from: 'usual' } : null;
}

export function rOf(trade) {
  const r = riskOf(trade);
  return r ? netPnl(trade) / r.risk : null;
}

export const rText = (r) => (r === null || !Number.isFinite(r) ? '—' : `${r > 0 ? '+' : ''}${(Math.round(r * 100) / 100).toFixed(2)}R`);
